<div class="flex flex-col gap-2"
     [formGroup]="form()"
>
  @if (section().generalLabel) {
    <albert-checkbox controlName="checkbox"
                     [attr.data-test]="dataTestPrefix() + '-' + section().dataTestSlug + '-general-confirmation'"
                     [disabled]="!canEdit()"
                     [groupName]="section().key"
                     [inputId]="dataTestPrefix() + '-' + section().key + 'GeneralConfirmation'"
                     [label]="section().generalLabel ?? ''"
    />
  }

  <div class="flex items-center gap-2">
    <p-checkbox [binary]="true"
                [disabled]="!canEdit()"
                [inputId]="dataTestPrefix() + '-' + section().key + 'FreetextCheckbox'"
                [ngModelOptions]="{ standalone: true }"
                [ngModel]="section().enabled()"
                (ngModelChange)="section().enabled.set($event)"
    />
    <label class="font-medium cursor-pointer"
           [for]="dataTestPrefix() + '-' + section().key + 'FreetextCheckbox'"
    >{{ section().freetextLabel }}</label>
  </div>

  @if (section().enabled()) {
    <albert-input-wrapper controlName="freetext"
                          [attr.data-test]="'wrapper-' + dataTestPrefix() + '-' + section().dataTestSlug + '-freetext'"
                          [disabled]="!canEdit()"
                          [groupName]="section().key"
                          [tooltipLabel]="section().freetextLabel"
    >
      <albert-textarea controlName="freetext"
                       [attr.data-test]="dataTestPrefix() + '-' + section().dataTestSlug + '-freetext'"
                       [disabled]="!canEdit()"
                       [groupName]="section().key"
                       [inputId]="dataTestPrefix() + '-' + section().key + 'Freetext'"
                       [label]="section().freetextLabel"
                       [required]="section().required"
                       [rows]="6"
      />
    </albert-input-wrapper>
  }
</div>
